/* Skin tone is order personalization; physical size/style remain Shopify variants. */
(function () {
  'use strict';

  function buildProperties(context, variantId) {
    const { config, variants, tone } = context;
    if (!config.values.includes(tone)) throw new Error('Please choose a skin tone.');
    const source = variants[String(variantId)]?.[tone];
    if (!source) throw new Error('Skin tone selection is temporarily unavailable. Please reload this page.');
    return {
      'Skin Tone': tone,
      _skin_tone_source_sku: source.sku,
      _skin_tone_source_variant_id: source.variantId,
      _skin_tone_option_name: config.sourceOptionName
    };
  }

  function enrichJson(payload, lookup) {
    function enrichItem(item) {
      const context = lookup(item?.id);
      return context ? { ...item, properties: { ...item.properties, ...buildProperties(context, item.id) } } : item;
    }
    if (!payload || typeof payload !== 'object') return payload;
    return Array.isArray(payload.items) ? { ...payload, items: payload.items.map(enrichItem) } : enrichItem(payload);
  }

  function enrichFormData(body, lookup) {
    const context = lookup(body.get('id'));
    if (!context) return body;
    const result = new FormData();
    for (const [key, value] of body.entries()) result.append(key, value);
    for (const [key, value] of Object.entries(buildProperties(context, body.get('id')))) {
      result.set(`properties[${key}]`, value);
    }
    return result;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { buildProperties, enrichJson, enrichFormData };
  }
  if (typeof window === 'undefined' || window.__preaSkinToneInstalled) return;
  window.__preaSkinToneInstalled = true;
  const contexts = new WeakMap();

  function lookup(variantId) {
    const roots = Array.from(document.querySelectorAll('[data-prea-skin-tone]'));
    roots.sort((a, b) => Number(b.getClientRects().length > 0) - Number(a.getClientRects().length > 0));
    for (const root of roots) {
      let context = contexts.get(root);
      if (!context) {
        try {
          const data = JSON.parse(root.querySelector('[data-prea-skin-tone-config]').textContent);
          context = { config: data.config, variants: data.variants, root };
          contexts.set(root, context);
        } catch (error) {
          console.error('Unable to load skin tone options.', error);
          continue;
        }
      }
      if (!Object.prototype.hasOwnProperty.call(context.variants, String(variantId))) continue;
      return { ...context, tone: root.querySelector('[data-prea-skin-tone-select]').value };
    }
    return null;
  }

  function showError(error) {
    for (const root of document.querySelectorAll('[data-prea-skin-tone]')) {
      const status = root.querySelector('[data-prea-skin-tone-error]');
      status.textContent = error.message;
      status.hidden = false;
    }
  }

  // Native ATC uses FormData while the existing personalizer sends JSON.
  // Adapt only mapped variant IDs on cart/add so both paths save identical data.
  const previousFetch = window.fetch;
  window.fetch = function (input, init) {
    const address = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
    const url = new URL(address, window.location.href);
    if (url.origin !== window.location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(url.pathname) || !init?.body) {
      return previousFetch.apply(this, arguments);
    }
    try {
      let body = init.body;
      if (body instanceof FormData) body = enrichFormData(body, lookup);
      else if (typeof body === 'string') {
        let payload;
        try { payload = JSON.parse(body); } catch (_) { return previousFetch.apply(this, arguments); }
        body = JSON.stringify(enrichJson(payload, lookup));
      }
      return previousFetch.call(this, input, { ...init, body });
    } catch (error) {
      showError(error);
      return Promise.reject(error);
    }
  };

  // Also populate standard fields for regular form submits and integrations
  // constructing FormData directly. Resolve from the current variant at submit.
  document.addEventListener('formdata', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.action)) return;
    const id = event.formData.get('id');
    const context = lookup(id);
    if (!context) return;
    try {
      for (const [key, value] of Object.entries(buildProperties(context, id))) {
        event.formData.set(`properties[${key}]`, value);
      }
    } catch (error) { showError(error); }
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-prea-skin-tone-select]')) return;
    const root = event.target.closest('[data-prea-skin-tone]');
    root.querySelector('[data-prea-skin-tone-error]').hidden = true;
  });
})();
